import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axiosInstance from '../config';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

const useStyles = makeStyles((theme) => ({
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0.3rem 0',
  },
}));

const OpLog = ({sub, id, username, setUsername, open, setOpen}) => {
  const classes = useStyles();
  const [totalPage, setTotalPage] = useState(null);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [OperationLog, setOperationLog] = useState([]);
  const handleForm = (e, value) => {
    if (e != null) e.preventDefault();
    let url = `/agent/agents/${id}/operationLog`;
    
    console.log('username = '+username);
    if (sub === 'Y' && username != null) {
      url = '/agent/subagents/'+username+'/operationLog';
    }
    console.log('url = '+url);
    axiosInstance
      .get(url, {
        params: {
          startDate: moment(startDate).format('DD-MM-YYYY'),
          endDate: moment(endDate).format('DD-MM-YYYY'),
          pageNo: value - 1,
          pageSize: 30,
        },
      })
      .then((res) => {
        console.log(res.data);
        setOperationLog(res.data.content);
        setTotalPage(res.data.totalPages);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    console.log('oplog');
    if (open === true && username != null) handleForm(null, 1);
  }, [startDate, endDate, open, username]);

  return (
    <>
      {open === true ? (
        <>
          <div className="d-flex justify-content-between my-3 px-3 align-items-center ">
          
            <form action="" onSubmit={handleForm} id="form">
              <div className="text-dark d-flex align-items-center">
                <strong>Start Date:</strong>
                <DatePicker
                  selected={startDate ? startDate : new Date()}
                  onChange={(date) => setStartDate(date)}
                  className="mx-2"
                  dateFormat="d MMM yyyy"
                />
                <div>
                  <strong>End Date:</strong>
                  <DatePicker
                    selected={endDate ? endDate : new Date()}
                    onChange={(date) => setEndDate(date)}
                    className="mx-2"
                    dateFormat="d MMM yyyy"
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="table-responsive-sm mx-2">
            <button
              className="btn btn-sm btn-primary px-1 py-1 my-2"
              onClick={() => {
                setOpen(false);
                setUsername(null);
                setOperationLog([]);
              }}
            >
              Return
            </button>
            <table className="table table-sm table-striped table-bordered">
              <thead className="text-center thead-dark">
                <tr>
                  <th>No.</th>
                  <th>Time</th>
                  <th>Username</th>
                  <th>IP</th>
                  <th>Activity Type</th>
                  <th>Created By</th>
                  <th>Error Code</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody className="text-center">
                {OperationLog.map((op, index) => (
                  <tr key={op.pubId} className="text-center ">
                    <td className="text-secondary">{index + 1}</td>
                    <td className="text-secondary">
                      {moment(op.createdAt).format('DD MMM h:mm a')}
                    </td>
                    <td className="text-secondary">{op.username}</td>
                    <td className="text-secondary">{op.ip}</td>
                    <td className="text-secondary">{op.activityType}</td>
                    <td className="text-secondary">{op.createdBy}</td>
                    <td className="text-secondary">{op.errorCode}</td>
                    <td className="text-secondary">{op.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination
              count={totalPage}
              onChange={handleForm}
              className={classes.pagination}
            />
          </div>
        </>
      ) : (
        <span>{open}</span>
      )}
    </>
  );
};

export default OpLog;
